import { useMutation, UseMutationOptions, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { QueryKey } from "common/enums/query-key";
import { BackendError } from "common/types/errors/backendError";
import { declineBackgroundCheck } from "services/api/background-check-api.service";
import { notification } from "services/services";

type Variables = { applicationId: string, orderPlanIds: string[] }
export function useDeclineBackgroundCheck(options?: UseMutationOptions<void, AxiosError<BackendError>, Variables, unknown>) {
  const queryClient = useQueryClient();

  return useMutation({
    ...options,
    mutationFn: ({ applicationId, orderPlanIds }) => declineBackgroundCheck(applicationId, orderPlanIds),
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: [QueryKey.Offers] });
    },
    onSuccess: (data, variables, context) => {
      options?.onSuccess?.(data, variables, context);
      notification.success('Background check has been declined');
    },
    onError: (e) => {
      notification.error(e?.response?.data?.detail || 'The Background Check has not been declined');
    },
    ...options,
  });
}
